var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "aspect-ratio-box" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Aspect Ratio"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-muted font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")(_vm.currentAspectRatio.name))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "aspect-ratio-container" },
      _vm._l(_vm.aspectRatios, function (aspectRatio) {
        return _c(
          "div",
          {
            staticClass: "aspect-ratio-btn",
            class: { active: _vm.currentAspectRatio.name === aspectRatio.name },
            on: {
              click: function ($event) {
                return _vm.setAspectRatio(aspectRatio.size)
              },
            },
          },
          [
            _vm._v("\n      " + _vm._s(aspectRatio.size) + "\n      "),
            _c("div", { class: aspectRatio.style }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "checkmark-box",
                class: {
                  active: _vm.currentAspectRatio.name === aspectRatio.name,
                },
              },
              [_c("i", { staticClass: "fa fa-check" })]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }